module.exports = __webpack_public_path__ + "img/1508263104.2fc62e57.jpg";